import { createFileRoute } from "@tanstack/react-router";
import AuthError from "@/pages/AuthError";

export const Route = createFileRoute("/auth/error")({ component: AuthError });
